import React from 'react';
import { Form } from '../../../ui/form/components/form';
const DO_NOTHING = () => Promise.resolve({});
const NO_VALUES = {};
const NO_ERRORS = [];
const NestedForm = _ref => {
  let {
    id,
    form,
    value,
    onChange,
    errors,
    FieldLayout
  } = _ref;
  if (!form) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id
  }, /*#__PURE__*/React.createElement(Form, {
    form: form,
    values: value ?? NO_VALUES,
    onChange: onChange ?? DO_NOTHING,
    errors: errors ?? NO_ERRORS
  }));
};
export default NestedForm;
//# sourceMappingURL=nested-form.js.map